/*

  ______  _____   ______ _______  ______
 |_____/ |     | |  ____ |______ |_____/
 |    \_ |_____| |_____| |______ |    \_

 vehicle sales system

(c) 2006 - 2019 TCE <TCE-ITDevelopers@toyota-ce.com>

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.

*/

(function () {
  "use strict";

  angular
    .module("ROGER")

    //
    .controller("ShoppingCartItemController", [
      "$scope",
      "$http",
      "$sessionStorage",
      "$translate",
      "$uibModal",
      "$addressLookup",
      "customerService",
      "$messageBox",
      "$oidc",
      function (
        $scope,
        $http,
        $sessionStorage,
        $translate,
        $uibModal,
        $addressLookup,
        customerService,
        $messageBox,
        oidc
      ) {
        $scope.$storage = $sessionStorage;

        // Order types
        $scope.onChangeOrderType = function (newVal, oldVal) {
          if (newVal !== oldVal) {
            if (oldVal === 1) {
              $scope.resetSurvey();
            }

            if (newVal === 5 || newVal === 6 || newVal === 8) {
              $scope.loadFleets().then(function () {
                if ($scope.fleets.length === 0) {
                  $uibModal.open({
                    template: require("./ShoppingCartFleetNotAvailable.html"),
                    controller: "ShoppingCartFleetNotAvailableController",
                  });
                  $scope.item.orderType = oldVal;
                } else {
                  $scope.resetFleet();
                }
              });
            } else if (oldVal === 5 || oldVal === 6) {
              $scope.resetFleet();
            }

            $scope.loadCampaigns();
            $scope.resetCampaign();

            $scope.loadPostProductionOptions();
          }
        };

        $scope.getSalesOrderTypes = function () {
          return $scope.orderTypes;
        };

        $scope.$watch("item.orderType", function (newVal, oldVal) {
          $scope.onChangeOrderType(newVal, oldVal);
        });

        // Fleets
        $scope.loadFleets = function () {
          return $http
            .get("/api/fleet", {
              params: {
                salesOrderLineId: "",
                retailerId: $scope.$storage.retailer.Id,
                modelColorId: $scope.item.data.ModelColorId,
              },
              headers: {
                Authorization:
                  oidc.current.token_type + " " + oidc.current.access_token,
              },
            })
            .then(function (response) {
              $scope.fleets = response.data;
            });
        };

        $scope.resetFleet = function () {
          $scope.item.fleetModel = null;
        };

        //$scope.$watch("item.fleetModel", function (newVal, oldVal) {
        //    if (newVal !== oldVal) {
        //        $scope.loadCampaigns();
        //        $scope.resetCampaign();

        //        $scope.loadPostProductionOptions();
        //    }
        //});

        // Campaign
        $scope.loadCampaigns = function () {
          if ($scope.item.orderType != null) {
            $http
              .get("/api/campaign", {
                params: {
                  retailerId: $scope.$storage.retailer.Id,
                  modelColorId: $scope.item.data.ModelColorId,
                  salesOrderTypeId: $scope.item.orderType,
                  fleetModelId: $scope.item.fleetModel,
                  unitId: $scope.item.data.UnitId,
                  solFromResId: $scope.item.data.Id,
                },
                headers: {
                  Authorization:
                    oidc.current.token_type + " " + oidc.current.access_token,
                },
              })
              .then(function (response) {
                $scope.campaigns = response.data;
                $translate("CampaignNone").then(
                  function (translation) {
                    $scope.campaigns.splice(0, 0, {
                      Id: null,
                      Name: translation,
                      Description: "",
                    });
                  },
                  function () {
                    $scope.campaigns.splice(0, 0, {
                      Id: null,
                      Name: "None",
                      Description: "",
                    });
                  }
                );
              });
          }
        };

        $scope.resetCampaign = function () {
          $scope.item.campaign = null;
        };

        //$scope.$watch("item.campaign", function (newVal, oldVal) {
        //    if (newVal !== oldVal) {
        //        $scope.loadPostProductionOptions();
        //    }
        //});

        $scope.onCampaignChanged = function () {
          $scope.loadPostProductionOptions();
        };

        $scope.onFleetModelChanged = function () {
          $scope.loadCampaigns();
          $scope.resetCampaign();

          $scope.loadPostProductionOptions();
        };

        // Post production options
        $scope.loadPostProductionOptions = function () {
          return $http
            .get("/api/post-production-option", {
              params: {
                retailerId: $scope.$storage.retailer.Id,
                modelColorId: $scope.item.data.ModelColorId,
                salesOrderTypeId: $scope.item.orderType,
                campaignId: $scope.item.campaign,
                fleetModelId: $scope.item.fleetModel,
              },
              headers: {
                Authorization:
                  oidc.current.token_type + " " + oidc.current.access_token,
              },
            })
            .then(function (response) {
              $scope.item.postProductionOptions = response.data;
              for (
                var i = 0;
                i < $scope.item.postProductionOptions.length;
                i++
              ) {
                $scope.item.postProductionOptions[i].IsChecked =
                  $scope.item.postProductionOptions[i].IsMandatory ||
                  $scope.item.postProductionOptions[i].IsDefault ||
                  $scope.item.postProductionOptions[i].IsFromNewCampaign;
              }
            });
        };

        // Customer
        $scope.loadCustomer = function (customer) {
          return $scope.customerService
            .get($scope.$storage.retailer.Id, customer.Id)
            .then(function (cust) {
              $scope.item.customer = cust;
            });
        };

        $scope.setEmptyCustomer = function () {
          $scope.item.customer = {
            Id: 0,
            Address: {
              CountryId: $scope.$storage.retailer.CountryId,
            },
          };
        };

        $scope.customerService = customerService;

        $scope.customerOnSelect = function (customer) {
          if (typeof customer != "undefined" && customer != null) {
            if (customer.Id > 0) {
              $scope.loadCustomer(customer);
            } else {
              $scope.setEmptyCustomer();
            }
          } else {
            $scope.setEmptyCustomer();
          }
        };

        $scope.customerCancelEditMode = function () {
          $scope.item.customerSearchInfo = null;
          $scope.item.customer = {
            Address: {
              CountryId: $scope.$storage.retailer.CountryId,
            },
          };
        };

        $scope.customerIsInLookupMode = function () {
          return (
            typeof $scope.item.customer == "undefined" ||
            $scope.item.customer == null ||
            typeof $scope.item.customer.Id == "undefined" ||
            $scope.item.customer.Id == null
          );
        };

        $scope.customerIsInEditMode = function () {
          return !$scope.customerIsInLookupMode();
        };

        // Customer address
        $scope.addressLookup = function (searchText) {
          return $addressLookup.lookup(searchText).then(
            function (result) {
              return result;
            },
            function (error) {
              return error;
            }
          );
        };

        $scope.addressOnSelect = function (address) {
          if (typeof address != "undefined" && address != null) {
            $addressLookup.detail(address.place_id).then(function (result) {
              var house = "";
              var house2 = "";
              var street = "";
              var city = "";
              var postCode = "";
              var country = "";
              for (
                var index = 0;
                index < result.address_components.length;
                index++
              ) {
                if (result.address_components[index].types[0] === "premise") {
                  house = result.address_components[index].long_name;
                } else if (
                  result.address_components[index].types[0] === "street_number"
                ) {
                  house2 = result.address_components[index].long_name;
                } else if (
                  result.address_components[index].types[0] === "route"
                ) {
                  street = result.address_components[index].long_name;
                } else if (
                  result.address_components[index].types[0] === "locality"
                ) {
                  city = result.address_components[index].long_name;
                } else if (
                  result.address_components[index].types[0] === "postal_code"
                ) {
                  postCode = result.address_components[index].long_name;
                } else if (
                  result.address_components[index].types[0] === "country"
                ) {
                  country = result.address_components[index].short_name;
                }
              }
              $scope.item.customer.Address.Street = street;
              if (house != null && house.trim() !== "") {
                $scope.item.customer.Address.Street =
                  $scope.item.customer.Address.Street + " " + house;
              }
              if (house2 != null && house2.trim() !== "") {
                if (house != null && house.trim() !== "") {
                  $scope.item.customer.Address.Street =
                    $scope.item.customer.Address.Street + "/" + house2;
                } else {
                  $scope.item.customer.Address.Street =
                    $scope.item.customer.Address.Street + " " + house2;
                }
              }
              $scope.item.customer.Address.City = city;
              $scope.item.customer.Address.PostCode = postCode;
              $scope.item.customer.Address.CountryId =
                $scope.getCountryIdByIsoShort(country);
            });
          }
        };

        // Survey
        $scope.resetSurvey = function () {
          $scope.item.survey = {
            Previous: null,
            Alternative: null,
          };
        };

        // Remove item from shopping cart
        $scope.remove = function () {
          $uibModal
            .open({
              template: require("./ShoppingCartItemRemove.html"),
              controller: "ShoppingCartItemRemoveController",
              resolve: {
                item: function () {
                  return $scope.item;
                },
              },
            })
            .result.then(
              function () {},
              function () {}
            );
        };

        //
        $scope.resetSurvey();

        if ($scope.item.orderType != null) {
          // Fleet
          if (typeof $scope.item.fleetModel == "undefined") {
            $scope.resetFleet();
          }

          if ($scope.item.fleetModel != null) {
            $scope.loadFleets();
          }

          // Campaign
          if (typeof $scope.item.campaign == "undefined") {
            $scope.resetCampaign();
          }
          $scope.loadCampaigns();
        }

        // Customer
        if (
          typeof $scope.item.CustomerCountryId == "undefined" ||
          $scope.item.CustomerCountryId == null
        ) {
          $scope.item.CustomerCountryId = $scope.$storage.retailer.CountryId;
        }
      },
    ]);
})();
